/** Domain kuralı ihlali. `code` arayüzde çeviri anahtarı olarak kullanılır. */
export class DomainError extends Error {
  readonly code: string;
  /**
   * İstemciye gösterilebilen ayrıntı kodu (ör. `UNSUPPORTED_FILE_TYPE` için `macro`); arayüz
   * çözümü bu kodla anlatır. `message` iç ayrıntıdır, istemciye gönderilmez.
   */
  readonly detail: string | undefined;

  constructor(code: string, message?: string, detail?: string) {
    super(message ?? code);
    this.name = 'DomainError';
    this.code = code;
    this.detail = detail;
  }
}
